import JsCookies from 'js-cookie';

import Env from '../../services/environment';
import { FLAGS } from '../../constants';

const EnvVars = Env.vars();

// Toggle whole Split functionality.
export const SPLIT_ENABLED = true;

export const cookieSplitAnonymUserKey = 'splitAnonymousUserKey';

export function prepareUserKey() {
  let splitUserKey = JsCookies.get(cookieSplitAnonymUserKey);

  if (splitUserKey) {
    return splitUserKey;
  }

  const randomKey = Math.ceil(Math.random() * 899999 + 100000);
  splitUserKey = `${randomKey}_GUEST`;
  JsCookies.set(cookieSplitAnonymUserKey, splitUserKey, {
    expires: 365,
  });

  return splitUserKey;
}

export default {
  startup: {
    requestTimeoutBeforeReady: 3,
    retriesOnFailureBeforeReady: 0,
  },
  core: {
    authorizationKey: EnvVars.SPLIT_IO_KEY,
    key: prepareUserKey(),
    trafficType: 'user',
  },
  sync: {
    splitFilters: [
      {
        type: 'byName',
        values: Object.keys(FLAGS).map((k) => FLAGS[k]),
      },
    ],
  },
  storage: {
    type: 'LOCALSTORAGE',
  },
  debug: EnvVars.SPLIT_ENV !== 'production',
};
